import { Reducer } from "redux"
import { BrowserType, AuthUserType } from "../../Actions/Types"
import { LocalStorageData } from "../../Models/Client/LocalStorage"
import { load, save } from "../../Helpers/Functions/localStorage"
import { unique } from "../../Helpers/Functions/array"
import { TemplateInstantiateAction } from "../API/AppTemplate/Interface/TemplateInstantiateReducer"
import { UserAction } from "../Auth/UserReducer"

export type BrowserState = LocalStorageData

interface BrowserAcceptCalibrationJobAction {
    type: BrowserType.acceptCalibrationJob
    meta: {
        instanceID: string
    }
}

export type BrowserAction = BrowserAcceptCalibrationJobAction

const emptyState: BrowserState = {
    calibrationJobAcceptedInstanceIds: []
}

const initialState: BrowserState = load() || emptyState

export const BrowserReducer: Reducer<
    BrowserState,
    BrowserAction | TemplateInstantiateAction | UserAction
> = (state = initialState, action): BrowserState => {
    function reduce(): BrowserState {
        switch (action.type) {
            case BrowserType.acceptCalibrationJob:
                return {
                    ...state,
                    calibrationJobAcceptedInstanceIds: unique(
                        state.calibrationJobAcceptedInstanceIds.concat([
                            action.meta.instanceID
                        ])
                    )
                }
            /*
            TODO:
            we can persist onboarding status in browser storage again
            once we solve the issue in persisting file objects.

            case OnboardingType.start:
            case OnboardingType.setInstanceID:
            case OnboardingType.addJobID:
            case OnboardingType.setJobOutput:
                return {
                    ...state,
                    onboardingData: {
                        ...state.onboardingData,
                        ...action.payload
                    }
                }
            case OnboardingType.clear:
                return {
                    ...state,
                    onboardingData: undefined
                }
                */
            case AuthUserType.signedOut:
                return emptyState
            default:
                return state
        }
    }

    const updated = reduce()

    if (JSON.stringify(state) !== JSON.stringify(updated)) {
        save(updated)
    }

    return updated
}
